/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : SubscriptionEvaluationConverter.ts
*******************************************/

import { CTA_NAME, CTA_OUTCOME, CTAStatsDetails } from "@api-commons/stats/CTATypes.js";
import { EvaluatedActionType, isProposeSubscription, ProposeSubscription } from "../../EvaluatedAction.js";
import { EvaluationConverter } from "../EvaluationConverter.js";

export class SubscriptionEvaluationConverter implements EvaluationConverter {
    public check = isProposeSubscription;
    
    public convert(action: ProposeSubscription): CTAStatsDetails {
        if (action.type == EvaluatedActionType.PROPOSE_PUSH_NOT_SUBSCRIPTION || EvaluatedActionType.AFTER_LOGIN_EVENTUALLY_PROPOSE_NOTIFICATIONS) {
            return {
                outcome: CTA_OUTCOME.SHOWN,
                action: CTA_NAME.SUBSCRIBE,
                source_element: "evaluation"
            };
        }
        else if (action.type == EvaluatedActionType.SUGGEST_RE_ENABLE_LEGACY_PUSH_NOT) {
            return {
                outcome: CTA_OUTCOME.SHOWN,
                action: CTA_NAME.PUSH_CHECK,
                source_element: "evaluation"
            };
        }
        else if (action.type == EvaluatedActionType.PROPOSE_FOLLOW) {
            return {
                outcome: CTA_OUTCOME.SHOWN,
                action: CTA_NAME.FOLLOW,
                source_element: "evaluation",
                url: action.data?.url
            };
        }
    }
}